export class AnydoError<Type extends string, Code extends string | number = string | number> extends Error {
  readonly name: string = this.constructor.name;

  // Custom
  readonly type: Type;
  readonly code!: Code;

  constructor(type: Type, message = "") {
    super(message);

    this.type = type;
  }

  toString(): string {
    return `AnydoError: ${this.message}`;
  }
}
